import { defineMessages } from 'react-intl';

export const scope = 'app.components.ParentAccountPage';

export const messages = defineMessages({
  accountIntro: {
    id: `${scope}.accountIntro`,
    defaultMessage: 'Your verified and active profile information is detailed below. You can edit and update your name, verified emails, mobile numbers, and relationship to each of your connected players.',
  },
  perPlayerContactsHeading: {
    id: `${scope}.perPlayerContactsHeading`,
    defaultMessage: 'Per-player contact details',
  },
  perPlayerContactsEmpty: {
    id: `${scope}.perPlayerContactsEmpty`,
    defaultMessage: 'We\'ll list your players here once your association links you to a roster.',
  },
  perPlayerContactsOpen: {
    id: `${scope}.perPlayerContactsOpen`,
    defaultMessage: 'Choose which verified email or phone we use for each player.',
  },
  perPlayerContactsClosed: {
    id: `${scope}.perPlayerContactsClosed`,
    defaultMessage: 'Tap to manage how we contact you about each of your {count} {playerNoun}.',
  },
  errKeepOneCredential: {
    id: `${scope}.errKeepOneCredential`,
    defaultMessage: 'Keep at least one email or phone for this player',
  },
});
